/* Independent Decision Presale. Same global time-based interpolation as the original; not an order API. */
if (!customElements.get('ys-t5-presale')) {
  customElements.define('ys-t5-presale', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.initializing) return;
      this.initializing = true;
      // A parser/editor may connect the root before its children are inserted.
      queueMicrotask(() => {
        this.initializing = false;
        if (this.isConnected && !this.controller) this.initialize();
      });
    }

    initialize() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const progress = this.querySelector('[data-tdp-progress]');
      if (progress) {
        const anchor = Number(progress.dataset.anchor);
        const end = Number(progress.dataset.end);
        const initial = Number(progress.dataset.initial) || 0;
        const target = Number(progress.dataset.target);
        const total = Number(progress.dataset.total) || 1;
        const word = progress.dataset.word || '';
        const current = progress.querySelector('[data-tdp-current]');
        const fill = progress.querySelector('[data-tdp-fill]');
        const bar = progress.querySelector('[role=progressbar]');
        const label = progress.querySelector('[data-tdp-end-label]');
        const render = () => {
          const now = Date.now();
          let value = initial;
          if (anchor > 0 && end > anchor && now > anchor) {
            value = now >= end ? target : initial + (target - initial) * (now - anchor) / (end - anchor);
          }
          value = Math.max(0, Math.min(total, Math.floor(value)));
          current.textContent = value;
          fill.style.width = (value / total * 100) + '%';
          bar.setAttribute('aria-valuenow', value);
          bar.setAttribute('aria-valuetext', value + ' of ' + total + (word ? ' ' + word : ''));
          if (label) label.textContent = end > 0 && now >= end && progress.dataset.endedLabel ? progress.dataset.endedLabel : progress.dataset.endLabel;
          if (end > 0 && now >= end) this.stopTimer();
        };
        render();
        if (end > Date.now() && end > anchor && target !== initial) this.timer = window.setInterval(render, 15000);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); }, options);
      }

      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-tdp-open]');
      this.fallback = this.querySelector('[data-tdp-fallback]');
      this.rules = this.querySelector('[data-tdp-rules-content]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.opener || !this.rules) return;
      this.dialog.querySelector('[data-tdp-dialog-content]').append(this.rules);
      this.fallback.hidden = true;
      this.opener.hidden = false;
      this.opener.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        this.scrollLocked = true;
        document.documentElement.style.overflow = 'hidden';
        this.opener.setAttribute('aria-expanded', 'true');
      }, options);
      this.dialog.querySelector('[data-tdp-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')]
          .filter(element => element.getClientRects().length && !element.closest('[hidden],[inert]'));
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      this.dialog.addEventListener('click', event => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        this.opener.setAttribute('aria-expanded', 'false');
        if (this.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }

    stopTimer() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    unlockScroll() {
      if (!this.scrollLocked) return;
      document.documentElement.style.overflow = this.previousOverflow || '';
      this.scrollLocked = false;
    }

    disconnectedCallback() {
      this.stopTimer();
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
      if (this.fallback && this.rules) {
        this.fallback.append(this.rules);
        this.fallback.hidden = false;
      }
      if (this.opener) {
        this.opener.hidden = true;
        this.opener.setAttribute('aria-expanded', 'false');
      }
    }
  });
}
